import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ICardFeesFormMeta {
    customizationFees: FormInputMeta;
    renewalFees: FormInputMeta;
    membershipFees: FormInputMeta;
    pinRecalculationFees: FormInputMeta;

    schema: any;
}

const cardFeesFormMeta = {} as ICardFeesFormMeta;

cardFeesFormMeta.customizationFees = {
  name: "customizationFees",
  type: "select",
  label: "Frais Personnalisa.",
  placeholder: "",
  validation: yup.string(),
};

cardFeesFormMeta.renewalFees = {
  name: "renewalFees",
  type: "select",
  label: "Frais Renouvel.",
  placeholder: "",
  validation: yup.string(),
};

cardFeesFormMeta.membershipFees = {
  name: "membershipFees",
  type: "select",
  label: "Frais d'Adhésion",
  placeholder: "",
  validation: yup.string(),
};

cardFeesFormMeta.pinRecalculationFees = {
  name: "pinRecalculationFees",
  type: "select",
  label: "Frais Re-Calcul Pin",
  placeholder: "",
  validation: yup.string(),
};


cardFeesFormMeta.schema = yup.object().shape(getValidationSchema(cardFeesFormMeta));

export default cardFeesFormMeta;